import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { isAuthorizedUser } from '../utils/constants';

/**
 * Guard di componente per la pagina batch: solo l'utente il cui username
 * normalizzato è "paul" può accedere. Chiunque altro (anche digitando l'URL a
 * mano) viene reindirizzato senza vedere la pagina.
 *
 * L'autorizzazione reale resta lato server (403 per gli altri utenti); questo è
 * il controllo speculare lato client.
 */
export default function RouteGuard({ children }) {
  const { user, initialCheckDone } = useAuth();

  // Aspetta il completamento del check di sessione prima di decidere.
  if (!(initialCheckDone ?? false)) return null;

  if (!isAuthorizedUser(user)) {
    return <Navigate to="/sisketron/macrofunzionipage" replace />;
  }

  return children;
}
